// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import getUniquePageLink, { BaseUniquePageLink } from "@store/Framework/Common/Utilities/getUniquePageLink";

const useUniquePageLinks = <T extends BaseUniquePageLink>(pageLinks: T[] | undefined) => {
    const dispatch = useAppDispatch();
    const uniqueIdsByPageType = useAppSelector(state => state.store.links.uniqueIdsByPageType);

    if (!pageLinks) {
        return pageLinks;
    }

    return pageLinks.map(x => getUniquePageLink(x, dispatch, uniqueIdsByPageType));
};

export default useUniquePageLinks;
